import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { Flexbox } from '@/ui/flexbox/flexbox';
import { Header, PilotHeader } from '@/ui/typography/widgets';
import { Button } from '@/ui/button/button';
import { useLogout } from '@/auth/hooks/use-logout.mutation';

export function AccountDisabledPage() {
  const { t } = useTranslation('auth');
  const logout = useLogout();
  return (
    <Flexbox
      name="account-disabled-container"
      justify="center"
      alignItems="center"
      fullWidth
      fullHeight
    >
      <Flexbox name="page-not-found-content" direction="column" gap="12px">
        <PilotHeader>{t`accountDisabled.title`}</PilotHeader>
        <Header>{t`accountDisabled.subtitle`}</Header>
        <Info>
          {t`accountDisabled.subtitle2`}
          <br />
          <br />
          <Button
            size="big"
            variant="gray"
            onClick={logout}
          >{t`accountDisabled.submitButton`}</Button>
        </Info>
      </Flexbox>
    </Flexbox>
  );
}

const Info = styled('div')`
  ${({ theme }) =>
    theme.typography.actionsPanel.acrossPanel.searchOrCommentText}

  a {
    color: ${({ theme }) => theme.colors.basics.black};
  }
`;
